<template>
    <HomeHeaderComponent />
    <div class="container-fluid over-ons-block-home">
        <div class="container d-flex flex-column flex-lg-row">
            <img class="img-fluid rounded" src="img/mensen-van-creaal.webp" alt="Mensen van Creaal" />
            <div class="p-0 pt-5 mx-5 p-lg-5">
                <span class="text">
                    <h1 class="py-3">{{ $t('home.we_are_creaal') }}</h1>
                </span>
                <p>
                    {{ $t('home.we_are_creaal_p1') }}<br /><br />
                    {{ $t('home.we_are_creaal_p2') }}<br /><br />
                    {{ $t('home.we_are_creaal_p3') }}
                </p>
            </div>
        </div>
    </div>

    <div class="labels-block">
        <div class="container">
            <h2>{{ $t('menu.labels') }}</h2>
            <div class="py-4">{{ $t('home.labels_expl') }}</div>
        </div>
    </div>
    <div class="labels-home container d-none d-lg-flex">
        <div class="row">
            <div class="col-xl-4 col-lg-6 col-xs-12" v-for="label in labels" :key="label.id">
                <router-link :to="'/labels/' + label.content.slug + '/details'">
                    <div class="image-container">
                        <img class="" :src="label.content.image[0].url" height="400">
                    </div>
                </router-link>
                <div class="label-text">
                    <h5>{{ label.content.title[$i18n.locale] }}</h5>
                    <span>
                        {{ label.content.description[$i18n.locale] }}
                    </span>
                    <br /><br />
                    <router-link :to="'/labels/' + label.content.slug + '/details'">{{ $t('common.read_more') }} &#8594;</router-link>
                </div>
            </div>

        </div>
    </div>
    <div class="labels-home d-flex d-lg-none">
        <carousel :autoplay="2000" :items-to-show="1.1" :wrap-around="true">
            <slide v-for="label in labels" :key="label.id">
                <div class="car-card mx-3">
                    <router-link :to="'/labels/' + label.content.slug + '/details'">
                        <div class="image-container">
                            <img :src="label.content.image[0].url" height="400">
                        </div>
                    </router-link>
                    <div class="label-text">
                        <h5>{{ label.content.title[$i18n.locale] }}</h5>
                        <span>
                            {{ label.content.description[$i18n.locale] }}
                        </span>
                        <br /><br />
                        <router-link :to="'/labels/' + label.content.slug + '/details'">{{ $t('common.read_more') }} &#8594;</router-link>
                    </div>
                </div>
            </slide>
            <template #addons>
            </template>
        </carousel>
    </div>


    <div class="container-fluid over-ons-block-methode px-2 py-5">
        <div class="container">
            <h1 style="color: #fff;">{{ $t('home.creaal_method_title') }}</h1>
        </div>


        <div class="container d-flex flex-column">
            <div class="row pt-3 pt-md-4">
                <div class="col-12 col-md-6 pt-md-3 pt-3">
                    <h5>{{ $t('home.creaal_method_h1') }}</h5>
                    <p>{{ $t('home.creaal_method_p1') }}</p><br>
                    
                    <h5>{{ $t('home.creaal_method_h2') }}</h5>
                    <p>{{ $t('home.creaal_method_p2') }}</p><br>

                    <h5>{{ $t('home.creaal_method_h3') }}</h5>
                    <p>{{ $t('home.creaal_method_p3') }}</p>
                </div>
                <div class="col-12 col-md-6 pt-md-3 pt-3">
                    <h5>{{ $t('home.creaal_method_h4') }}</h5>
                    <p>{{ $t('home.creaal_method_p4') }}</p><br>
                    
                    <h5>{{ $t('home.creaal_method_h5') }}</h5>
                    <p>{{ $t('home.creaal_method_p5') }}</p>
                </div>
            </div>
        </div>
    </div>

    <div class="owners-block">
        <OwnerComponent></OwnerComponent>
    </div>

    <div class="adres-block">
        <div class="row">
            <div class="col-lg-3 offset-lg-3 col-12">
                <h2>{{ $t('home.our_location') }}</h2>
                <div class="address">
                    Creaal BV<br />
                    Bergweidedijk 18<br />
                    7418 AA Deventer <br />
                    {{ $t('footer.netherlands') }}<br />
                </div>
            </div>
            <div class="col-lg-6 col-12">
                <div class="office-img"></div>
            </div>
        </div>
    </div>


</template>

<script>
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide } from 'vue3-carousel'
import HomeHeaderComponent from '@/components/HomeHeaderComponent.vue';
import OwnerComponent from '@/components/OwnerComponent.vue';

export default {
    name: 'HomePage',
    components: {
    HomeHeaderComponent,
    Carousel,
    Slide,
    OwnerComponent
},
    data() {
        return {
            labels: [],
            owners: []
        };
    },
    methods: {
        fetchlabels() {
            const baseURL = 'contenttypes/labels/entries?';

            this.$http.get(baseURL)
                .then(response => {
                    let labels = response.data.data;
                    labels.forEach((label) => {
                        if(label.content.title.nl !== 'Nouvelly' && label.content.title.en !== 'Nouvelly') {
                            this.labels.push(label);
                        }
                    });
                }).catch(error => {
                    console.log("this fetching has error", error)
                })
        },
        fetchowners() {
            const baseURI = 'contenttypes/owners/entries?';

            this.$http.get(baseURI)
                .then(response => {
                    this.owners = response.data.data
                }).catch(error => {
                    console.log("this fetching has error", error)
                })
        }

    },
    created() {
        this.fetchlabels();
        this.fetchowners();

    },

}


</script>

<style>
body {
    overflow-x: hidden;
    overflow-y: scroll;
    max-width: 100%;
}

.text {
    line-height: 2.4;
}

h1,
h2,
h3,
h4 {
    color: #1e154a;
    font-weight: 700;
    font-family: 'Rubik';
}

h5 {
    color: #fff;
    font-weight: 700;
    font-family: 'Rubik';
}

p {
    color: #565872;
    font-weight: 400;
}

#app {
    overflow-x: hidden;
    overflow-x: clip;
    max-width: 100%;
}

.home-block {
    margin-left: 80px;
    margin-right: 80px;
    position: relative;
    z-index: 2;
}
.owners-block{
    background-color: #e9eff5;
}

.container-fluid .img {
    background-image: url('../../public/img/home.webp');
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;
    height: 530px;
}

.container-fluid .img .container {
    height: 100%;
    padding: 75px 18px;
}

.transparent-block {
    background: rgba(255, 255, 255, 0.33);
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(16.3px);
    -webkit-backdrop-filter: blur(16.3px);
    max-width: 510px;
    padding-bottom: 20px;
    border-radius: 5px;
    transform: translateY(10px)
}

.transparent-block .header {
    padding-top: 80px;
    margin-left: 40px;
    margin-right: 40px;
    padding-bottom: 20px;
    border-bottom: solid 1px #1e154a;
    display: block;
}

.transparent-block .header h1 {
    color: #1e154a;
    font-weight: 900;
}

.transparent-block .subheader {
    color: #1e154a;
    margin-top: 15px;
    margin-left: 40px;
    margin-right: 40px;
}

.transparent-block .header-button {
    margin: 20px 40px;
}

.transparent-block .header-button a {
    color: #fff;
    background-color: #9f8053;
    border-radius: 3px;
    font-size: 14px;
    padding: 15px 40px;
}

.bottom-bar {
    background-color: #1e154a;
    margin-left: 0px !important;
    margin-right: 0px !important;
    padding-left: 100px;
    padding-right: 40px;
    font-size: 14px;
    padding-top: 20px;
    padding-bottom: 20px;
    z-index: 2;
}

.principle {
    margin-top: 40px !important;
    margin-bottom: 40px !important;
    color: #fff !important;
    text-align: left;
}

.principle .icon {
    float: right !important;
    margin-top: 12px !important;
    color: #9f8053 !important;
    font-size: 25px !important;
}

.principle span {
    display: block;
}

.over-ons-block-home {
    margin-top: -120px;
    margin-left: 0px;
    margin-right: 0px;
    background-color: #e9eff5;
    padding-top: 185px;
    padding-bottom: 80px;
    position: relative;
    z-index: -1;
    line-height: 2;
}

.over-ons-block-methode {
    margin-top: 85px;
    margin-left: 0px;
    margin-right: 0px;
    background-color: #1e154a;
    position: relative;
    z-index: -1;
    line-height: 2;
}


/* .margin-minus { margin-top: -120px; } */
.over-ons-block-home span {
    color: #525561;
}

.over-ons-block-methode p {
    /* padding: 25px 0; */
    color: white;
}

/* .over-ons-button a {
    color: #fff;
    background-color: #9f8053;
    border-radius: 3px;
    font-size: 14px;
    padding: 15px 40px;
} */

.labels-block {
    background-color: #1e154a;
    color: #fff;
    text-align: center;
    padding-top: 85px;
    padding-bottom: 230px;
}

.labels-block .container {
    margin-bottom: 75px;
}

.labels-block h2 {
    color: #fff;
    text-align: center;
}

.labels-home {
    margin-top: -233px;
}

.labels-home a {
    text-decoration: none;
}

.labels-home img {
    max-width: 100%;
    vertical-align: middle;
    display: inline;
    object-fit: contain;
    max-height: 240px;
    padding-left: 80px;
    padding-right: 80px;
    padding-top: 30px;
    padding-bottom: 30px;
}

.labels-home .image-container {
    border: 5px solid #e9eff5;
    background-color: #fff;
    margin-top: -11px;
    border-radius: 7px 7px 0 0;
    text-align: center;
}

.labels-home .label-text {
    width: 100%;

    max-height: 235px;
    background-color: #e9eff5;
    padding: 50px;
    padding-top: 25px;
    border-radius: 0 0 7px 7px;
}

.car-card {
    max-width: 450px;
}

.labels-home .label-text h5 {
    color: #1e154a;
    font-weight: 900;
}

.labels-home .label-text span {
    color: #1e154a;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
}

.labels-home .label-text a {
    color: #9f8053;
    text-decoration: none;
}

.adres-block {
    background-color: #e9eff5;
    color: #fff;
    margin-top: 200px;
    position: relative;
    margin-left: 0px;
    margin-right: 0px;
}

.adres-block h2 {
    color: #1e154a;
    padding-top: 90px;
    padding-bottom: 50px;
}

.adres-block .address {
    color: #1e154a;
    padding-bottom: 110px;
    max-height: 400px;
}

.adres-block .office-img {
    background-image: url('../../public/img/visiting-address.jpg');
    background-repeat: no-repeat, repeat;
    background-position: center;
    background-size: cover;
    width: 100%;
    height: 120%;
    position: relative;
    top: -80px;
    min-height: 400px;
}
.line-text {
    line-height: 2;
}

@media (max-width: 991px) {
    .bottom-bar {
        padding-left: 0;
        padding-right: 0;
    }

    .principle {
        font-size: 18px;
    }

    .principle .icon {
        font-size: 30px !important;
    }

    .transparent-block {
        left: 50px;
    }

    .adres-block .office-img {
        top: 0px;
        max-height: 200px;
    }

    .adres-block h2,
    .adres-block .address {
        text-align: center;
    }

    .people-block .person-title {
        margin-bottom: 20px;
    }
}

@media (max-width: 575px) {
    .transparent-block {
        left: 0px;
        position: static;
        width: 100%;
    }

    .container-fluid .img {
        height: fit-content;
    }

    .container-fluid .img .container {
        padding: 25px 18px;
    }

    .adres-block {
        margin-top: 50px;
    }

    .adres-block .office-img {
        top: 0px;
    }

    .adres-block h2,
    .adres-block .address {
        text-align: center;
    }

    .bottom-bar .principle div {
        width: 64%;
    }

    .home-block {
        margin-left: 0px;
        margin-right: 0px;
    }
}

.labels-home > .row {
    justify-content: center;
}

.container > .img-fluid {
    object-fit: cover;
}

</style>